import React from 'react';
import './ExportPopup.less';

const ExportPopup = ({ onClose, onSelectExcel, onSelectImage }) => {
    return (
        <>
            <div className="export-mask" onClick={onClose} />
            <div className="pc-fixed-center export-popup-container">
                <div className="export-popup-wrap" onClick={(e) => e.stopPropagation()}>
                    <div className="popup-drag-bar" />
                    <div className="popup-option-list">
                        <div className="popup-option" onClick={onSelectExcel}>导出Excel表格</div>
                        <div className="popup-option" onClick={onSelectImage}>导出图片</div>
                    </div>
                    <div className="popup-cancel-btn" onClick={onClose}>取消</div>
                </div>
            </div>
        </>
    );
};

export default ExportPopup;